import Statistical from './Statistical.jsx';

export {
  Statistical
}


// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/statistical/index.js